import { cn } from "@/lib/utils";

const SIZE = {
  md: {
    container: "p-1",
    button: "px-3 py-1.5 text-sm",
    icon: 14,
  },
  sm: {
    container: "p-0.5",
    button: "px-2.5 py-1 text-xs",
    icon: 12,
  },
};

const PillTabs = ({ tabs, value, onChange, size = "md", className }) => {
  const s = SIZE[size] || SIZE.md;
  return (
    <div
      className={cn(
        "inline-flex items-center rounded-full bg-muted",
        s.container,
        className,
      )}
    >
      {tabs.map((tab) => (
        <button
          type="button"
          key={tab.value}
          onClick={() => onChange(tab.value)}
          className={cn(
            "inline-flex items-center gap-1.5 rounded-full font-medium transition-colors",
            s.button,
            value === tab.value
              ? "bg-card text-primary shadow-sm"
              : "text-muted-foreground hover:text-foreground",
          )}
        >
          {tab.icon && <tab.icon size={s.icon} />}
          {tab.label}
          {tab.count != null && (
            <span className="text-xs tabular-nums opacity-60">{tab.count}</span>
          )}
        </button>
      ))}
    </div>
  );
};

export default PillTabs;
